'use client';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import SelectInput from '@/components/common/ui/input/SelectInput';
import CaseStudySingle from '@/components/common/ui/single-item/CaseStudySingle';
import Masonry from 'react-layout-masonry';
import getImpactDataJson from '@/public/json/page/impact-stories.json';
import getTypesJson from '@/public/json/type_list.json';
import reactHtmlParser from 'react-html-parser';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { useShowSetting } from '@/core/context/ShowSettingProvider';
import useDeviceTypeMobile from '@/components/hooks/useDeviceTypeMobile';
import { StyledStroriesList } from '@/components/common/ygen/sections/stories-list/stories-list.style';
import getBrandProductDataJson from '@/public/json/brand_category_list.json';

const StroriesList = ({ data, impactData, typeData, productBrandData }) => {
	const [getImpactData, setImpactData] = useState(getImpactDataJson); // Store scroll data in state
	const [getTypeData, setTypeData] = useState(getTypesJson); // Store scroll data in state
	const [getTypeDataAll, setTypeDataAll] = useState(0); // Store scroll data in state
	const isMobile = useDeviceTypeMobile()
	const [getBrandProductData, setBrandProductData] = useState(getBrandProductDataJson); // Store scroll data in state

	const scroll = useShowSetting()

	useEffect(() => {
		if(getImpactDataJson){
			setImpactData((getImpactDataJson))
		}
		if(getTypesJson){
			setTypeData((getTypesJson))
		}
	}, [getImpactDataJson, setImpactData, getTypesJson, setTypeData]);


	const types = [
		{ value: 0, label: "All Categories" },
		...getTypeData.map(item => ({
			value: item.id,
			label: reactHtmlParser(item.title)
		}))
	];
	const productBrandOption = [
		{ value: 0, label: "All Brand" },
		...getBrandProductData.map(item => ({
			value: item.id,
			label: reactHtmlParser(item.title),
			slug: item?.slug
		}))
	];


	const handleClickSelect = (index) => {
		setTypeDataAll(index?.value)
		setTimeout(() => {
			scroll?.getScrollData?.update?.(); // Optional, if you're using smooth scroll
			ScrollTrigger.refresh();
		}, 100); // 50–100ms works well


	};



	return (
		<StyledStroriesList className="JobList" data-scroll-section>

			<Container>

				<Row>
					<Col md={4}>
						<SelectInput onChange={handleClickSelect} options={types} placeholder={'All Categories'} />
					</Col>

				</Row>
				{
					getImpactData?.child_pages?.list &&
					getImpactData?.child_pages?.list?.length > 0 &&

					<Masonry columns={isMobile ? 2 :4} gap={isMobile ? 15: 30} className="row masonary-row">
						{getImpactData?.child_pages?.list
							?.filter((e) => getTypeDataAll === 0 || getTypeDataAll === e?.types?.id)
							?.map((e, index) => {
								const thumb = e?.images?.list?.find(f => f?.thumb === 'on');

								return (
									<div className="show fade-up" key={index}>
										<CaseStudySingle
											hover="#DD223F"
											noPara
											link={`/impact-stories/${e?.page_data?.slug}`}
											subColor="rgba(21,38,55,0.5)"
											color="#152637"
											img={thumb?.full_path}
											title={e?.page_data?.title}
											subject={reactHtmlParser(e?.types?.title)}
										/>
									</div>
								);
							})}
					</Masonry>



				}

			</Container>
		</StyledStroriesList>
	);
};



export default React.memo(StroriesList);
